import { render, staticRenderFns } from "./EditProductPage.vue?vue&type=template&id=a8f53352&scoped=true&"
import script from "./EditProductPage.vue?vue&type=script&lang=js&"
export * from "./EditProductPage.vue?vue&type=script&lang=js&"
import style0 from "./EditProductPage.vue?vue&type=style&index=0&id=a8f53352&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8f53352",
  null
  
)

export default component.exports